import React from 'react';
import PropTypes from 'prop-types';
import { Resource, DownloadLink } from '../../components';

const MainResources = ({ assetsDownloadLink }) =>
  <div className="col-sm-12 main-resources">
    <h2 className="resource-headline">Auth0 Logo</h2>
    <p className="resource-subheadline">
      This is the Auth0 Logo and should be used in most situations, either on light or dark
      backgrounds. Don’t separate or rearrange the logotype and the badge symbol.
    </p>
    <Resource
      src="https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-logo-main-6001cece68.svg"
      alt="Auth0 Main Logo"
      title="Main Logo"
      description="This is the main Auth0 logo. This version should be used whenever posible. It works best over white or light grey backgrounds."
    />
    <Resource
      inverted="inverted"
      src="https://cdn.auth0.com/website/assets/pages/press/img/resources/auth0-logo-inverted-f7fc1c2059.svg"
      alt="Auth0 Inverted Logo"
      title="Inverted Logo"
      description="The inverted version is designed to work well on dark backgrounds."
    />
    <DownloadLink link={assetsDownloadLink} />
  </div>;

MainResources.propTypes = {
  assetsDownloadLink: PropTypes.string.isRequired
};

export default MainResources;



// WEBPACK FOOTER //
// ./src/pages/press/components/MainResources/MainResources.js